import { authConstants } from './constants';

const INITIAL_STATE = { 
    displayError: false ,
    isSubmitting: false,
    session: {},
    sysParams: []
 };


export function auth(state = INITIAL_STATE, action) {
   switch (action.type) {

  
    case authConstants.LOAD_SYS_PARAMS:
        return {
            ...state,
            sysParams : action.sysParams
           };  

    case authConstants.SESSION_OK:
        return {
            ...state,
            session : action.session
           };  
    case (authConstants.SESSION_INVALID || authConstants.SESSION_NOT_FOUND || authConstants.SESSION_VOID):
    return {
        ...state,
        session : {}
        };     
   
     case authConstants.LOGIN_REQUEST:
        return {
            ...state,
            isSubmitting: true,

           };  
     case authConstants.LOGIN_SUCCESS:
      return {
        ...state,
        displayError: false, 
        isSubmitting: false,
        session: action.session
       };
    case authConstants.LOGIN_FAILURE:
      return {
        ...state,
        displayError: true, 
        isSubmitting: false,
        session: {}
      };
    case authConstants.LOGOUT:
        return {
            ...state,
            session : {}
           };


    case authConstants.UPDATE_USER_PROFILE:
      let sessionNew = {...state.session, user: {...state.session.user, ...action.userUpdate} }
      localStorage.setItem("session",JSON.stringify(sessionNew)) ;
      return {
          ...state,
          session: sessionNew
          }; 

        
    default:
      return state
  }
}

